import { ConstrainMode, DetailsListLayoutMode, DetailsRow, IColumn, IDetailsFooterProps, IDetailsListProps, IDetailsListStyles, IDetailsRowStyles, IGroup, IGroupDividerProps, IGroupHeaderProps, IRenderFunction, IStyle, mergeStyleSets, ScrollablePane, ScrollbarVisibility, Selection, SelectionMode, ShimmeredDetailsList, Stack, StackItem, IStackStyles, Label, DetailsHeader, IDetailsRowProps, IDetailsList, ContextualMenu, IContextualMenuProps, DirectionalHint, Point, Sticky, StickyPositionType, IDragDropContext, MarqueeSelection, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchOpenExtensionHelper } from "../../src/taskpane/components/helpers/SearchOpenExtensionHelper";
import NewFolderPanel from "../../src/taskpane/components/panels/NewFolderPanel";
import { AutomationPanel, IFileApproval } from "../../src/taskpane/components/_v2/components/Panels/AutomationPanel/AutomationPanel";
import { useLazyGetItemWebUrlQuery } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-slice";
import { useLazyRenderListAsStreamByIDQuery } from "../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { WebPanel } from "../../src/taskpane/components/_v2/_shared/WebPanel/WebPanel";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { CopyMoveErrors, displayHeight, OneNoteProgId, rowLockIndicator, SharePointFolderContentTypeIds } from "../../src/taskpane/config/constants";
import { destinationHoldsQueuedRows } from "../../src/taskpane/components/helpers/copyJobSourcePaths";
import { getExpectedArrivalNames, haveArrived } from "./helpers/copyMoveArrival";
import { isGridKeyTarget } from "./helpers/gridKeyTarget";
import type { ContentManagerDestinationMoveCheck } from "../../src/taskpane/redux/models/reduxModels";
import { previewWebPanelStyles } from "../../src/taskpane/config/controlStyles";
import { ISearchOpenFileInfo } from "../../src/taskpane/interfaces/ISearchOpenFileInfo";
import authModule from "../../utilities/AuthModule";
import { buildItemErrorMessage, ItemError } from "../../utilities/ApiErrorHelper";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { CMCheckinModal } from "../Panels/CMCheckinModal";
import { CMDeleteModal } from "../Panels/CMDeleteModal";
import { CMFileInfoPanel, InfoPanelMode } from "../Panels/CMFileInfoPanel";
import { CMFilePreviewPanel, MoveDirection, SearchSource } from "../Panels/CMFilePreviewPanel";
import { usePreviewTargetName } from "../Panels/usePreviewTargetName";
import { CMRenameModal } from "../Panels/CMRenameModal";
import { CMUploadFilesPanel } from "../Panels/CMUploadFilesPanel";
import { CMVersionHistoryModal } from "../Panels/CMVersionHistoryModal";
import { ContentBodyCommandBar } from "./ContentBodyCommandBar";
import { UnfilledPlaceholdersMessageBar } from "./UnfilledPlaceholdersMessageBar";
import { ScanErrorsMessageBar } from "./ScanErrorsMessageBar";
import { CMPlaceholderSuggestPanel } from "../Panels/CMPlaceholderSuggestPanel";
import { Slide, ToastContainer } from "react-toastify";
import { CM_BODY_TOAST_CONTAINER_ID } from "./MenuItems/useMenuItem_ScanCustomFields";
import { gridSelectedItems } from "./ContentManagerBody";
import { useContentManagerBody, ViewTypes } from "./useContentManagerBody";
import { useMenuItems } from "./MenuItems/useMenuItems";
import { logger } from "../../utilities/logger";
import { CMErrorModal } from "../Panels/CMErrorModal";
import { CMVersionAppRejModal } from "../Panels/CMVersionAppRejModal";
import { CMFileFilterPanel } from "../Panels/CMFileFilterPanel/CMFileFilterPanel";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // import plugin
import { useMenuItem_QuickFilter } from "./MenuItems/useMenuItem_QuickFilter";
import { usePreselectFilters } from "./hooks/usePreselectFilters";
import { useRenameShortcut } from "./hooks/useRenameShortcut";
import { SharePointInputData } from "../../src/taskpane/interfaces/props/SharePointInputData";
import { IFileToUpload } from "../../src/taskpane/interfaces/IFileToUpload";
import { RootState } from "../../src/taskpane/redux";
import { setContentManagerExchangeProgress, setContentManagerMoveTo, setContentManagerMoveToCopyJobResults, setContentManagerMoveToError, setContentManagerMoveToSelectedFilesIsBusyProgress, setContentManagerSearchValue, toggleContentManagerReload } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { buildCopyMoveFailureUpdate } from "./helpers/copyMoveFailure";
import { sectionsHaveTokenRiskySelection } from "../Panels/CMFileFilterPanel/preselectStrike";
import { CMMoveFilesListPanel } from "../Panels/CMMoveFilesListPanel";
import { CMConfirmModal } from "../Panels/CMConfirmModal";
import { ContentManagerCopyMoveModeEnum } from "../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";
import { createCopyJobs, getListSettings } from "../../src/taskpane/services/SharePointRestServices";
import { CMFileSharePanel, SharePanelMode } from "../Panels/CMFileSharePanel";
import { CMShareWithGroupPanel } from "../Panels/CMShareWithGroupPanel";
import { useClientGroupShareGroups } from "../../src/taskpane/components/hooks/useClientGroupShareGroups";
import { IClientGroupShareSource } from "../../src/taskpane/services/clientGroupShareService";
import { isShareWithGroupLocation } from "./MenuItems/shareWithGroupEligibility";
import { HixUploadPanel } from "../../src/taskpane/components/panels/HixUploadPanel";
import { resolveCmHixUploadItems, isCmUploadableFile } from "./MenuItems/hixUploadResolver";
import { CMCancelAssignmentModal } from "../Panels/Nintex/CMCancelAssignmentModal";
import { setLastApprovalLoad } from "../../src/taskpane/redux/modules/approvals";
import { CMDuplicateFileVersionSelectorModal } from "../Panels/CMDuplicateFileVersionSelectorModal";
import { DraggableContainer } from "../../src/taskpane/components/_v2/components/Explorer/FolderView/DraggableContainer";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { addWorkingDirectory } from "../../src/taskpane/redux/modules/workingDirectory";
import generalModule from "../../utilities/GeneralModule";
import { DragAndDropHelper, DragMode } from "../../utilities/DragAndDropHelper";
import { addUploadedFiles } from "../../src/taskpane/redux/modules/file";
import { getListItemWebUrl } from "../../src/taskpane/services/GraphService";
import { tryGetPathname } from "../../src/taskpane/components/helpers/urlPathname";
import { isValidHttpUrl } from "../../src/taskpane/components/helpers/UrlHelper";
import { SigningPanel } from "../../src/taskpane/components/_v2/components/Panels/SigningPanel/SigningPanel";
import { BackgroundTaskStatusEnum } from "../../src/taskpane/components/enums/BackgroundTaskStatusEnum";
import { CMFilesUpdatePanel } from "../Panels/CMFilesUpdatePanel";
import { NewDocumentTemplate } from "../../src/taskpane/interfaces/IDocumentTemplate";
import { CMNewLinkPanel } from "../Panels/CMNewLinkPanel";
import { CMFileUploadProgressPanel } from "../Panels/CMFileUploadProgressPanel";
import { ViewTile } from "../../src/taskpane/components/_v2/components/Tile/ViewTile";
import { ILibraryPlace, libraryPlace } from "../../src/taskpane/services/copilot/copilotFileRefs";
import { useCopilotGridOffer } from "../Copilot/useCopilotGridOffer";
import { useCopilotFileSource } from "../Copilot/useCopilotFileSource";
import { setCopilotDragSource } from "../Copilot/copilotDragSource";
import { useContentManagerCopilotEnabled } from "../Copilot/useContentManagerCopilot";
const searchIconSrc = require("../../assets/empty_search.svg");
dayjs.extend(utc);

const classNames = {
  row: "listRow",
  optionButton: "listRowOptionButton",
  gripperIcon: "gripperIcon"
};

export const detailsListClassNames = mergeStyleSets({
  // The viewport budget (displayHeight) is shared by any message bars AND the
  // grid — a fixed grid height left a stacked message bar overflowing the
  // fixed-height body Stack with nothing scrollable to reach it (same bug class,
  // and same fix, as the all-documents viewport). The command bar stays OUTSIDE
  // the viewport: displayHeight's 152px already budgets header + breadcrumb +
  // command bar, so nesting the bar here would count its height twice and leave
  // a command-bar-sized dead strip below the grid's horizontal scrollbar.
  viewport: {
    height: displayHeight,
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    position: "relative",
    flex: "1 1 auto",
    minHeight: 0,
  },

  row: [classNames.row, {}],

  optionButton: [
    classNames.optionButton,
    {
      visibility: "hidden",
      display: "none",
      [`.${classNames.row}:hover &`]: {
        visibility: "visible",
        display: "block",
      },
      [`.${classNames.row}.is-selected &`]: {
        visibility: "visible",
        display: "block",
      },
    },
  ],

  gripperIcon: [
    classNames.gripperIcon,
    {
      visibility: "hidden",
      [`.${classNames.row}:hover &`]: {
        visibility: "visible",
        cursor: "grab"
      },
      [`.${classNames.row}.is-selected &`]: {
        visibility: "visible",
        cursor: "grab"
      },
      [`.${classNames.row}:active &`]: {
        visibility: "visible",
        cursor: "grabbing"
      },
    },
  ],
});

export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    margin: "0 0 0 0",
    padding: "0px",
    MsOverflowStyle: "scrollbar"
  },
  headerWrapper: {
    paddingTop: 0
  }
};

const noResultsStackStyles: Partial<IStackStyles> = {
  root: { width: "100%", height: "calc(100vh - 250px)", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

const loadingSpinnerStackStyles: Partial<IStackStyles> = {
  root: { height: 100, width: "100%", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

const headerCountStyle: IStyle = { display: 'none' };

const rowStyles: Partial<IDetailsRowStyles> = {
  cell: {
    display: "inline-flex",
    alignItems: "flex-start"
  },
  checkCell: {
    display: "inline-flex",
    alignItems: "flex-start"
  }
};

export interface IExternalResourceUrl {
  url: string;
  description?: string;
};

export interface IContentBodyFilesFoldersProps {
}

export interface IGridColumn extends IColumn {
  internalName: string;
}

export const ContentBodyFilesFolders = (props: IContentBodyFilesFoldersProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const tenantEnablePII = useSelector((state: RootState) => state.user.tenantEnablePII);
  const workingDirectories = useSelector((state: RootState) => state.workingDirectories.workingDirectories);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
  const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories.oneDriveRootDetails);
  const userAccount = useSelector((state: RootState) => state.user.account);
  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
  const filterFields = useSelector((state: RootState) => state.contentManagerDirectory.filterFields);
  const moveToEnabled = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.moveToEnabled);
  const moveToDirectory = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.workingDirectories.length > 0 ? state.contentManagerDirectory.moveTo.workingDirectories[state.contentManagerDirectory.moveTo.workingDirectories.length - 1] : null);
  const moveToIsMoveComplete = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.isMoveComplete);
  const moveToMode = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.mode);
  const moveTo = useSelector((state: RootState) => state.contentManagerDirectory.moveTo);
  const moveToSourceServerRelPath = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.sourceServerRelPath);
  // An operation with no single source folder (the all-documents aggregate view)
  // supplies a label instead of a path; fall back to the path for every other flow.
  const moveToSourceDisplayName = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.sourceDisplayName);
  const exchangeProgress = useSelector((state: RootState) => state.contentManagerDirectory.exchange.progress);
  const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
  const mode = useSelector((state: RootState) => state.mode.mode);
  const hideAutoPreview = useSelector((state: RootState) => state.tenantInfo?.hideAutoPreview);
  // Derived, not stored: keep the grid shimmering while a token-risky (Lookup/User/
  // Taxonomy) pre-select is still reconciling — the fast fetch #1 used raw values
  // and may be empty/wrong, so painting it would flash an empty "no results".
  // Both inputs live in redux, so this can never desynchronize from them. The
  // pending check MUST stay first: it short-circuits the section scan to O(1) in
  // steady state, and the selection-aware helper keeps this exactly equal to the
  // old stored flag in every commit (see sectionsHaveTokenRiskySelection).
  const preselectSuppressGrid = useSelector((state: RootState) =>
    state.contentManagerDirectory.preselectReconcilePending &&
    sectionsHaveTokenRiskySelection(state.contentManagerDirectory.filterSections));

  const [selectedItemInfo, setSelectedItemInfo] = React.useState<ISearchOpenFileInfo>(null);
  const [selectedItem, setSelectedItem] = React.useState<any>();
  const [openContextMenu, setOpenContextMenu] = React.useState<{ open: boolean, position: Point }>({ open: false, position: null });
  const [selectedItems, setSelectedItems] = React.useState<gridSelectedItems>({ items: [], count: 0 });
  const [selectionCleared, setSelectionCleared] = React.useState<boolean>(false);
  const [waitFor, setWaitFor] = React.useState<boolean>();
  const [waitForContext, setWaitForContext] = React.useState<string>(languageStrings?.LoadingOnly)
  const [isCMCreateFolderPanelOpen, setIsCMCreateFolderPanelOpen] = React.useState(false);
  const [isCMCreateLinkPanelOpen, setIsCMCreateLinkPanelOpen] = React.useState(false);
  const [isCMUploadFilesPanelOpen, setIsCMUploadFilesPanelOpen] = React.useState(false);
  const [showRenameDialog, setShowRenameDialog] = React.useState(false);
  const [isCMFileInfoPanelOpen, setIsCMFileInfoPanelOpen] = React.useState(false);
  const [infoPanelMode, setInfoPanelMode] = React.useState<InfoPanelMode>();
  const [isApprovalsPanelOpen, setIsApprovalsPanelOpen] = React.useState(false);
  const [isSigninPanelOpen, setIsSigningPanelOpen] = React.useState(false);
  const [isFileUploadProgressPanelOpen, setIsFileUploadProgressPanelOpen] = React.useState(false);
  const [approvalFiles, setApprovalFilesState] = React.useState<IFileApproval[]>([]);
  // Automation started from the open location (nothing selected) rather than from selected rows.
  const [automationAtLocation, setAutomationAtLocation] = React.useState(false);
  // Any other start (selected rows, signing) leaves the location mode.
  const setApprovalFiles = React.useCallback((files: IFileApproval[]) => { setAutomationAtLocation(false); setApprovalFilesState(files); }, []);
  const openAutomationAtLocation = React.useCallback((container: IFileApproval | null) => {
    setApprovalFilesState(container ? [container] : []);
    setAutomationAtLocation(true);
    setIsApprovalsPanelOpen(true);
  }, []);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  const [showCancelAssignmentDialog, setShowCancelAssignmentDialog] = React.useState(false);
  const [showVersionHistoryDialog, setShowVersionHistoryDialog] = React.useState(false);
  const [showDuplicateFileVersionSelectorModal, setShowDuplicateFileVersionSelectorModal] = React.useState(false);
  const [isPublish, setIsPublish] = React.useState(false);
  const [showCheckinDialog, setShowCheckinDialog] = React.useState(false);
  const [isCMFilePreviewPanelOpen, setIsCMFilePreviewPanelOpen] = React.useState(false);
  // Name of the file a .url link points at, once the preview panel has resolved it.
  const [previewTargetName, setPreviewTargetName] = usePreviewTargetName(selectedItem);
  const [isCMVersionAppRejModalOpen, setIsCMVersionAppRejModalOpen] = React.useState(false);
  const [isCMErrorModalOpen, setIsCMErrorModalOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isCMFileFilterPanelOpen, setIsCMFileFilterPanelOpen] = React.useState(false);
  const [isCMFileSharePanelOpen, setIsCMFileSharePanelOpen] = React.useState(false);
  const [isHixPanelOpen, setIsHixPanelOpen] = React.useState(false);
  const [isCMMoveFilesListPanelOpen, setIsCMMoveFilesListPanelOpen] = React.useState(false);
  const [selectedNewDocumentTemplate, setSelectedNewDocumentTemplate] = React.useState<NewDocumentTemplate>();
  const [unfilledPlaceholders, setUnfilledPlaceholders] = React.useState<string[]>([]);
  const [unusedCustomValues, setUnusedCustomValues] = React.useState<string[]>([]);
  const [unfilledColumnPlaceholders, setUnfilledColumnPlaceholders] = React.useState<string[]>([]);
  const [crmResolutionReasons, setCrmResolutionReasons] = React.useState<string[]>([]);
  const [scanCustomFieldsErrors, setScanErrorsList] = React.useState<string[]>([]);
  const [scanCustomFieldsSkipped, setScanSkippedList] = React.useState<string[]>([]);
  // Declared before the useMenuItems call below, which receives it as an argument -
  // a later const would still be in its temporal dead zone at that point.
  const setScanCustomFieldsErrors = React.useCallback((errors: string[], skipped?: string[]) => {
    setScanErrorsList(errors ?? []);
    setScanSkippedList(skipped ?? []);
  }, []);
  // AI placeholder suggestions: target of the "Suggest placeholders (AI)" menu item.
  // Post-apply scan errors reuse the SAME persistent bar as the scan command, so the AI
  // layer terminates into the existing warn-never-block surface.
  const [suggestPlaceholdersTarget, setSuggestPlaceholdersTarget] = React.useState<import("./MenuItems/useMenuItem_SuggestPlaceholders").ISuggestPlaceholdersTarget | undefined>();
  const openSuggestPlaceholdersPanel = React.useCallback(
    (target: import("./MenuItems/useMenuItem_SuggestPlaceholders").ISuggestPlaceholdersTarget) => setSuggestPlaceholdersTarget(target),
    []);
  const [quickFilterValue, setQuickFilterValue] = React.useState<string>("");
  const [showConfirmMoveToDialog, setShowConfirmMoveToDialog] = React.useState<boolean>(false);
  const [isBusyCreatingMoveToJobQue, setIsBusyCreatingMoveToJobQue] = React.useState<boolean>(false);
  const [htmlConfirmMessage, setHtmlConfirmMessage] = React.useState<JSX.Element>();
  const [isMarqueeEnabled, setIsMarqueeEnabled] = React.useState(true);
  const [externalResourceUrl, setExternalResourceUrl] = React.useState<IExternalResourceUrl>();
  const [showLoadingSpinner, setShowLoadingSpinner] = React.useState<boolean>(false);
  const [isLoadingNextPage, setIsLoadingNextPage] = React.useState<boolean>(false);

  const [renderListAsStreamByID] = useLazyRenderListAsStreamByIDQuery();
  const [getItemWebUrl] = useLazyGetItemWebUrlQuery();

  const itemUpdatedId = React.useRef<string | undefined>();
  const detailsListRef = React.useRef<IDetailsList>();
  const focusZoneRef = React.useRef<HTMLElement>();
  const isInOneDrive = React.useRef(false);
  const _selection = React.useRef(new Selection({
    onSelectionChanged: () => getSelectionDetails()
  }));
  const masterIdsRemoved = React.useRef<string[]>([]);

  const getSelectionDetails = () => {
    const filteredSelectedItems = _selection.current.getSelection().filter(x => x && x[rowLockIndicator] !== true);

    setSelectedItems({ items: filteredSelectedItems, count: filteredSelectedItems ? filteredSelectedItems.length : 0 });

    if (filteredSelectedItems?.length === 1) {
      let selectedItem: any = filteredSelectedItems[0];
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(selectedItem.ProgId === OneNoteProgId ? OneNoteProgId : selectedItem[".fileType"]));
      setSelectedItem(selectedItem);
    } else {
      setSelectedItemInfo(null);
      setSelectedItem(null);
    }
  }

  const fileInputRef = React.useRef<HTMLInputElement>();
  const folderInputRef = React.useRef<HTMLInputElement>();

  React.useEffect(() => {
    const handleDocumentBodyKeyDown = (event: any) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }
      // Spec 2.10: ignore keys that land elsewhere, such as in the Copilot pane.
      if (!isGridKeyTarget(event.target, renameShortcutGridRef.current)) {
        return;
      }

      if (event.key === "Delete" || event.keyCode === 46) {
        if (_selection.current.getSelection().length > 0) {
          setShowDeleteDialog(true);
        }
      }
      // Check if Ctrl (or Command on Mac) and "a" are pressed
      else if ((event.ctrlKey || event.metaKey) && event.key === "a") {
        event.preventDefault();
        _selection.current.setAllSelected(true);
      }
      else if (event.key === "Escape" && event.target === event.currentTarget) {
        _selection.current.setAllSelected(false);
      }
    };

    document.body.addEventListener("keydown", handleDocumentBodyKeyDown);

    return () => {
      document.body.removeEventListener("keydown", handleDocumentBodyKeyDown);
    };
  }, []);

  const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
  const openSharePanel = React.useCallback((mode: SharePanelMode) => {
    sharePanelModeRef.current = mode;
    setIsCMFileSharePanelOpen(true);
  }, []);

  // "Share with group": the member sites of the current site when it is a client group.
  // The site's groups (its own members, and every group it belongs to), resolved once per
  // directory through the session-cached group service; the menu item and the panel both read them.
  const clientListUrl = useSelector((state: RootState) => state.tenantInfo?.clientListUrl);
  const { groups: clientGroupShareGroups } = useClientGroupShareGroups(
    currentDirectory?.siteId,
    !!clientListUrl?.trim() && isShareWithGroupLocation(currentDirectory),
    currentDirectory?.siteDisplayName ?? languageStrings.ClientGroup,
  );
  const [isCMShareWithGroupPanelOpen, setIsCMShareWithGroupPanelOpen] = React.useState(false);
  const openShareWithGroupPanel = React.useCallback(() => setIsCMShareWithGroupPanelOpen(true), []);
  const resolveShareWithGroupSources = React.useCallback(async (): Promise<IClientGroupShareSource[]> => [{
    seedWebUrl: currentDirectory?.webUrl,
    seedListId: currentDirectory?.sharePointListId,
    seedUniqueIds: (selectedItems?.items ?? []).map(item => String(item?.UniqueId ?? "").replace("{", "").replace("}", "")).filter(id => id.length > 0),
  }], [selectedItems, currentDirectory?.webUrl, currentDirectory?.sharePointListId]);

  const pickFiles = React.useCallback(() => {
    fileInputRef.current?.click();
  }, [fileInputRef.current]);

  const pickFolder = React.useCallback(() => {
    folderInputRef.current?.click();
  }, [folderInputRef.current]);

  const handleSelectedFiles = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const filesToUpload: IFileToUpload[] = DragAndDropHelper.handleSelectedFiles(event);
    if (filesToUpload?.length > 0) {
      dispatch(addUploadedFiles(filesToUpload));
      setIsCMUploadFilesPanelOpen(true);
    }
    (event.target as HTMLInputElement).value = null;
  }, []);

  const clearItemSelection = React.useCallback(() => {
    _selection.current.setAllSelected(false);
    setSelectedItem(null);
    setSelectedItems({ items: [], count: 0 });
    setSelectedItemInfo(null);
  }, []);

  const triggerContextMenu = React.useCallback((ev: any, position?: Point) => {
    setOpenContextMenu({ open: true, position: position ?? { left: ev.clientX, top: ev.clientY } });
  }, []);

  const showFileInfo = React.useCallback(() => {
    setInfoPanelMode(InfoPanelMode.Update);
    setIsCMFileInfoPanelOpen(true);
  }, []);

  // const nintexDialogRef = React.useRef<any>();
  const [isReloadWatcherActive, setIsReloadWatcherActive] = React.useState<boolean>(false);
  const openCreateTemplateModal = React.useCallback((selectedTemplate: NewDocumentTemplate) => {
    setSelectedNewDocumentTemplate(selectedTemplate);

    if (selectedTemplate?.contentTypeId === "0x0120D520006AAF2894D132DC4490C0776F6D6D2CA40035E1CF0A0F777246BCE4531413CFCF86") {
      /**
       * adding winLeft and winTop to account for dual monitor
       * using screenLeft and screenTop for IE8 and earlier
       */
      const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
      const winTop = window.screenTop ? window.screenTop : window.screenY;
      /**
       * window.innerWidth displays browser window"s height and width excluding toolbars
       * using document.documentElement.clientWidth for IE8 and earlier
       */
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const left = Math.max(0, ((width / 2) - (600 / 2)) + winLeft);
      const top = Math.max(0, ((height / 2) - (800 / 2)) + winTop);

      //const nintexFormUrl: URL = new URL("https://xblox-574017.workflowcloud.com/forms/be3952f0-9079-4612-b518-9d5cf947b8f6");
      const nintexFormUrl: URL = new URL("https://xblox-574017.workflowcloud.com/forms/17f995a0-fbab-4cef-b89b-0c0e0b2a8f0a");
      // nintexDialogRef.current = window.open(nintexFormUrl.href, "Docubird.Nintex", `width=615, height=800, top=${top}, left=${left}, scrollbars=yes`);

      const nintexWin = window.open(nintexFormUrl.href, "Docubird.Nintex", `width=615, height=800, top=${top}, left=${left}, scrollbars=yes`);

      // const reloadInterval: number = 25000;
      // const reloadLimit: number = 2;
      // const timer = setInterval(() => {
      //   if (nintexWin.closed) {
      //     clearInterval(timer);
      //     let x = 0;
      //     let timeOutId = setTimeout(function reload() {
      //       // dispatch(toggleReload());
      //       if (++x === reloadLimit) {
      //         clearTimeout(timeOutId);
      //       } else {
      //         timeOutId = setTimeout(reload, reloadInterval);
      //       }
      //     }, reloadInterval);
      //   }
      // }, 1000);
      const intervalId = setInterval(() => {
        if (nintexWin.closed) {
          clearInterval(intervalId);
          setIsReloadWatcherActive(true);
        }
      }, 1000);

    } else if (selectedTemplate?.templateId === "NewFolder" || selectedTemplate?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) {
      setIsCMCreateFolderPanelOpen(true);
    } else if (selectedTemplate?.templateId === "NewLink") {
      setIsCMCreateLinkPanelOpen(true);
    } else if (workingDirectories?.some(x => x.type === ComponentTypes.SharePointList)) {
      setIsCMUploadFilesPanelOpen(true);
    }
    else {
      setInfoPanelMode(InfoPanelMode.NewTemplate);
      setIsCMFileInfoPanelOpen(true);
    }
  }, [workingDirectories]);

  const openFilePreviewFromLink = React.useCallback((item: any) => {
    setSelectedItem({ ...item });
    setIsCMFilePreviewPanelOpen(true);
  }, []);

  // Only an http(s) url opens in the panel's iframe: ItemHub takes broadcasts from anyone, and a
  // javascript: url there would run as app.docubird.com (spec follow-up 3, review 2026-10-20).
  const openExternalResourceUrl = React.useCallback((externalResourceUrl: IExternalResourceUrl) => {
    if (isValidHttpUrl(externalResourceUrl?.url)) {
      setExternalResourceUrl(externalResourceUrl);
    }
  }, []);

  const openFileInfoPanel = React.useCallback((itemIndex: number) => {
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(itemIndex, true, true);
    showFileInfo();
  }, []);

  const [pdfConvertIsDuplicate, setPdfConvertIsDuplicate] = React.useState<boolean>(false);
  const [pdfConvertShowVersion, setPdfConvertShowVersion] = React.useState<boolean>(false);

  const openDuplicateFileVersionSelectorModal = React.useCallback((isDuplicate: boolean, showVersion: boolean) => {
    setPdfConvertIsDuplicate(isDuplicate);
    setPdfConvertShowVersion(showVersion);
    setShowDuplicateFileVersionSelectorModal(true);
  }, []);

  const isSharePointList = React.useMemo(() => workingDirectories?.some(x => x.type === ComponentTypes.SharePointList), [workingDirectories]);

  const {
    isFetchingData,
    gridProps,
    viewsWithColumns,
    selectedView,
    scrollToTopToggle,
    isAllCollapsedRef,
    serverRelPath,
    folderPath,
    newDocumentTemplates,
    libraryMinVerEnabled,
    listTitle,
    listFields,
    listSchemaFields,
    listHttpRoot,
    setSelectedView,
    fetchGroupedDrillDownData,
    fetchGroupedDrillDownDataAllGroups,
    onSortColumn,
    reloadGrid,
    fetchListStreamNextPage,
    setGridProps,
    setIsFetchingData,
    getTimeZoneFormattedDate,
    onFolderClick
  } = useContentManagerBody(_selection.current, isSharePointList, triggerContextMenu, openFilePreviewFromLink, openFileInfoPanel, openExternalResourceUrl, clearItemSelection);

  // Field source for the preselect reconcile. Prefer the setup schema
  // (`listSchemaFields`, always present on SharePoint, stable ref identity) over
  // redux `filterFields` for two reasons:
  //  1. Redux filterFields is gated on grid rows > 0, so a filtered fetch #1 that
  //     returns 0 rows (a non-existent / token-mismatched value) leaves it empty —
  //     the schema fallback lets the reconcile still run and clear its flags.
  //  2. Using the stable schema ref avoids a mid-flight identity change (redux
  //     filterFields flips [] -> N when fetch #1 settles) that would otherwise
  //     cancel and restart an in-flight reconcile (a redundant RenderListFilterData
  //     batch). Both sources are the identical RenderListDataAsStream ListSchema.Field.
  // OneDrive has no early schema (getSharepointListSchema is SharePoint-only), so it
  // falls back to redux filterFields, which arrives with its own fetch.
  const preselectFilterFields = (listSchemaFields?.length > 0 ? listSchemaFields : filterFields) ?? [];

  usePreselectFilters({
    filterFields: preselectFilterFields,
    isInOneDrive: isInOneDrive.current,
    serverRelPath,
    selectedView,
    meText: languageStrings.Me,
    onApplied: () => setIsCMFileFilterPanelOpen(true),
    // Raise the fetch indicator so the shimmer stays continuous across a corrective
    // reload (no flash of the fetch #1 grid before fetch #2's shimmer engages).
    onReloadStart: () => setIsFetchingData(true),
  });

  const updateGridItems = React.useCallback(async (items: any[]) => {
    let serverRelativePath = '';
    if (currentDirectory?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.serverRelativePath) {
      serverRelativePath = currentDirectory?.serverRelativePath;
    }
    else if (currentDirectory?.directory?.length > 0 && currentDirectory?.parentId) {
      let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
      const results = await getItemWebUrl({ driveId, itemId: currentDirectory?.id, accessToken: await authModule.getGraphAccessToken() }).unwrap();
      const resolvedPath = tryGetPathname(results.listItem?.webUrl || results.webUrl);
      serverRelativePath = resolvedPath ? tryDecodeUriComponent(resolvedPath) : currentDirectory?.serverRelativePath ?? "";
    }

    const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;
    const accessToken = isInOneDrive?.current
      ? await authModule.getOneDriveAccessToken()
      : await authModule.getSharePointAccessToken();

    const updatedItems: any[] = await Promise.all(items.map(async item => {
      try {
        return renderListAsStreamByID({
          siteUrl,
          sharePointListId: currentDirectory?.sharePointListId,
          viewId: selectedView?.Id,
          accessToken,
          Id: item.ID,
          serverRelativePath
        }).unwrap();
      } catch (error) {
        // Ignore
      }
      return null;
    }))

    const updatedItemsMap = new Map(
      updatedItems.filter(Boolean).map(updatedItem => [updatedItem.ListData.Row[0].ID, updatedItem.ListData.Row[0]])
    );

    if (updatedItemsMap.size > 0) {
      setGridProps(currentGridProps => {
        if (!currentGridProps?.items) {
          return currentGridProps;
        }

        const newItems = currentGridProps.items.map(gridItem => {
          if (gridItem && updatedItemsMap.has(gridItem.ID)) {
            return { ...updatedItemsMap.get(gridItem.ID), isBusy: false };
          }
          return gridItem;
        });

        return { ...currentGridProps, items: newItems };
      });
    }

    getSelectionDetails();
  }, [
    currentDirectory,
    oneDriveRootDetails,
    selectedView,
    setGridProps,
    renderListAsStreamByID,
    getItemWebUrl,
    authModule
  ]);

  const setGridItemIsBusy = React.useCallback((items: any[], isBusy: boolean) => {
    const idsToUpdate = new Set(items.map(item => item.ID));

    setGridProps(currentGridProps => {
      if (!currentGridProps?.items) {
        return currentGridProps;
      }

      const updatedItems = currentGridProps.items.map(gridItem => {
        if (gridItem && idsToUpdate.has(gridItem.ID)) {
          return { ...gridItem, isBusy };
        }
        return gridItem;
      });

      return {
        ...currentGridProps,
        items: updatedItems,
      };
    });
  }, [setGridProps]);

  const { menuItem_QuickFilter, resetQuickFilterValue } = useMenuItem_QuickFilter(setQuickFilterValue);

  // Where the selected rows are, for Ask Copilot and the Copilot pane's offer (spec 2026-10-22 §2.5),
  // from what the grid already has. A SharePoint list has no files to ask about. OneDrive is read
  // from the directory itself: isInOneDrive is set in an effect, a render after navigating.
  const isCopilotOneDrive: boolean = currentDirectory?.type === ComponentTypes.OneDrive || currentDirectory?.type === ComponentTypes.OneDriveSubFolder;
  const copilotPlace = React.useMemo((): ILibraryPlace | null => !currentDirectory || isSharePointList ? null : libraryPlace({
    isOneDrive: isCopilotOneDrive,
    oneDriveDriveId: oneDriveRootDetails?.driveId ?? "",
    oneDriveSiteUrl: oneDriveRootDetails?.sharePointSiteUrl ?? "",
    oneDriveLabel: languageStrings.CopilotScopeOneDrive,
    currentDirectory,
    // OneDrive's own library ("Documents") is not part of its location: "OneDrive › folder".
    listTitle: isCopilotOneDrive ? "" : listTitle,
    folderPath
  }), [currentDirectory, isSharePointList, isCopilotOneDrive, oneDriveRootDetails, listTitle, folderPath, languageStrings]);

  const { contextMenu, commandBarMenu, deleteSuccess } = useMenuItems(
    mode,
    selectedItems.items,
    waitFor,
    setWaitFor,
    waitForContext,
    setWaitForContext,
    isInOneDrive.current,
    listFields,
    selectedItemInfo,
    setIsCMCreateFolderPanelOpen,
    setIsCMUploadFilesPanelOpen,
    setShowRenameDialog,
    setIsCMFileInfoPanelOpen,
    setInfoPanelMode,
    setApprovalFiles,
    setIsApprovalsPanelOpen,
    setShowDeleteDialog,
    setShowVersionHistoryDialog,
    setIsPublish,
    setShowCheckinDialog,
    gridProps,
    setGridProps,
    setSelectedItems,
    setIsCMFilePreviewPanelOpen,
    setSelectionCleared,
    setGridItemIsBusy,
    updateGridItems,
    viewsWithColumns,
    selectedView,
    setSelectedView,
    setIsCMErrorModalOpen,
    setErrorMessage,
    setIsCMVersionAppRejModalOpen,
    setIsCMFileFilterPanelOpen,
    newDocumentTemplates,
    openCreateTemplateModal,
    // quickFilterValue,
    gridProps?.items?.length > 0 && selectedItems.count === 0 && menuItem_QuickFilter,
    setIsCMMoveFilesListPanelOpen,
    setShowConfirmMoveToDialog,
    isFetchingData,
    openSharePanel,
    setShowCancelAssignmentDialog,
    libraryMinVerEnabled,
    openDuplicateFileVersionSelectorModal,
    reloadGrid,
    pickFiles,
    pickFolder,
    setIsSigningPanelOpen,
    setIsFileUploadProgressPanelOpen,
    setIsHixPanelOpen,
    setScanCustomFieldsErrors,
    openSuggestPlaceholdersPanel,
    clientGroupShareGroups,
    openShareWithGroupPanel,
    copilotPlace,
    openAutomationAtLocation
  );

  // The selection, offered to the Copilot pane while it is open and Copilot is on here (nothing is
  // written otherwise; final review 2026-10-22).
  const { enabled: isCopilotEnabled } = useContentManagerCopilotEnabled();
  useCopilotGridOffer("libraryGrid", selectedItems.items, copilotPlace, isCopilotOneDrive ? languageStrings.CopilotScopeOneDrive : listTitle, isCopilotEnabled);
  // Its rows can fill Specific files (ticks, Ask Copilot, a drag), so the open pane's hint names them.
  useCopilotFileSource("libraryGrid", isCopilotEnabled && copilotPlace !== null);

  // F2 = the Rename command. Looked up in the BUILT menu, not taken from the raw
  // menuItem_Rename, because buildMenuItems drops rename in copy/move mode: the
  // shortcut must offer exactly what the user can see.
  const renameMenuItem = React.useMemo(() => contextMenu?.find(item => item.key === "rename") ?? null, [contextMenu]);
  const renameShortcutGridRef = useRenameShortcut(renameMenuItem);

  React.useEffect(() => {
    if (moveTo.busyMovingFiles
      && moveTo.sourceDirectory?.id
      && currentDirectory?.id
      && moveTo.sourceDirectory.id === currentDirectory.id
      && moveTo.copyJobResultsCompletedIds?.length > 0) {

      let filteredList = moveTo.copyJobResultsCompletedIds?.filter(id => !masterIdsRemoved.current.includes(id));
      if (filteredList?.length > 0) {
        masterIdsRemoved.current.push(...moveTo.copyJobResultsCompletedIds);
        if (gridProps?.items?.length > 0) {
          const newRows: any[] = [];

          gridProps.items.forEach((item) => {
            //check for virtual scrolling null item
            if (item) {
              const shouldRemoveItemFromGrid = filteredList.includes(item.UniqueId?.toLowerCase().replace("{", "").replace("}", ""));
              if (!shouldRemoveItemFromGrid) {
                newRows.push(item);
              }
            }
          });

          setGridProps({ ...gridProps, items: [...newRows] });
        }
      }
    }
  }, [moveTo.busyMovingFiles, moveTo.copyJobResultsCompletedIds, moveTo.sourceDirectory, currentDirectory, gridProps]);

  React.useEffect(() => {
    if (currentDirectory) {
      isInOneDrive.current = currentDirectory.type == ComponentTypes.OneDrive || currentDirectory.type == ComponentTypes.OneDriveSubFolder;
      DragAndDropHelper.destinationDirectory = currentDirectory;
      if (generalModule.getOpenPanelUploadPanel()) {
        generalModule.setOpenPanelUploadPanel(false);
        setIsCMUploadFilesPanelOpen(true);
      }
    }
  }, [currentDirectory]);

  // The unfilled-placeholder warning describes a file created in THIS directory;
  // it must not follow the user into other folders. Returning the same reference when
  // already empty lets React bail out - navigation must not re-render this component
  // an extra time for a bar that is not even showing.
  React.useEffect(() => {
    setUnfilledPlaceholders(previous => (previous.length === 0 ? previous : []));
    setUnusedCustomValues(previous => (previous.length === 0 ? previous : []));
    setUnfilledColumnPlaceholders(previous => (previous.length === 0 ? previous : []));
    setCrmResolutionReasons(previous => (previous.length === 0 ? previous : []));
    setScanErrorsList(previous => (previous.length === 0 ? previous : []));
    setScanSkippedList(previous => (previous.length === 0 ? previous : []));
  }, [currentDirectory]);

  const dismissUnfilledPlaceholders = React.useCallback(() => {
    setUnfilledPlaceholders([]);
    setUnusedCustomValues([]);
    setUnfilledColumnPlaceholders([]);
    setCrmResolutionReasons([]);
  }, []);

  const handleCreateFromTemplateWarnings = React.useCallback((unfilled: string[], unused?: string[], columnPlaceholders?: string[], crmReasons?: string[]) => {
    setUnfilledPlaceholders(unfilled ?? []);
    setUnusedCustomValues(unused ?? []);
    setUnfilledColumnPlaceholders(columnPlaceholders ?? []);
    setCrmResolutionReasons(crmReasons ?? []);
  }, []);

  const dismissScanCustomFieldsErrors = React.useCallback(() => {
    setScanErrorsList([]);
    setScanSkippedList([]);
  }, []);

  // One delayed re-check is enough for the copy-job settle window, and it only ever runs
  // when the items are actually missing. More than this was what made the grid appear to
  // reload at random long after the operation had finished.
  const ARRIVAL_RETRY_DELAY_MS = 4000;
  const MAX_ARRIVAL_RETRIES = 1;

  const [pendingArrivalNames, setPendingArrivalNames] = React.useState<string[]>([]);
  const arrivalRetriesRef = React.useRef(0);
  const handledMoveCompletionRef = React.useRef(false);

  const reloadTimoutId = React.useRef<NodeJS.Timeout>();
  const stopReloadWatcher = () => {
    if (reloadTimoutId.current) {
      clearTimeout(reloadTimoutId.current);
      reloadTimoutId.current = null;
    }
    setIsReloadWatcherActive(false);
  }

  React.useEffect(() => {
    const reloadInterval: number = 10000;
    const reloadLimit: number = 3;
    if (isReloadWatcherActive) {
      let x = 0;
      reloadTimoutId.current = setTimeout(function reload() {
        reloadGrid();
        if (++x === reloadLimit) {
          clearTimeout(reloadTimoutId.current);
          stopReloadWatcher();
        } else {
          reloadTimoutId.current = setTimeout(reload, reloadInterval);
        }
      }, reloadInterval);
    }
    else if (reloadTimoutId?.current) {
      stopReloadWatcher();
    }

    return () => {
      if (reloadTimoutId?.current) {
        stopReloadWatcher();
      }
    }
  }, [currentDirectory, isReloadWatcherActive]);

  React.useEffect(() => {
    if (!isBusySaving) {
      reloadGrid();
    }
  }, [isBusySaving]);

  React.useEffect(() => {
    if (currentSharepointFolder.canCreateFolder !== undefined) {
      DragAndDropHelper.canCreateFolder = currentSharepointFolder.canCreateFolder;
    }
  }, [currentSharepointFolder.canCreateFolder]);

  React.useEffect(() => {
    if (!moveToIsMoveComplete) {
      // Armed again (or cancelled) — the next completion is a new one to react to.
      handledMoveCompletionRef.current = false;
      return;
    }

    masterIdsRemoved.current = [];

    // Belt-and-braces for THIS mount only; the redux clear at the bottom is what makes
    // the completion one-shot globally. Both are needed: the clear takes a dispatch to
    // land, and currentDirectory is a dependency here, so this effect can re-run in the
    // meantime on a directory object whose identity changed during the reload.
    if (handledMoveCompletionRef.current) {
      return;
    }
    if (moveTo.destinationDirectory?.id !== currentDirectory?.id) {
      // Not the destination, so nothing to reload and nothing to consume — the flag has
      // to survive for whenever the user does arrive there.
      return;
    }
    handledMoveCompletionRef.current = true;

    // The reload below races the server: JobState 0 means the copy job has left the
    // queue, not that the destination list will already return the new items. Rather
    // than reload again on a timer and hope, note what should arrive and let the effect
    // underneath check — when the server was already consistent, which is the common
    // case, that costs nothing at all.
    setPendingArrivalNames(getExpectedArrivalNames(moveTo.selectedFiles));
    arrivalRetriesRef.current = 0;
    reloadGrid();

    // Consume the signal. Nothing else in the app reads isMoveComplete, and it is
    // otherwise only lowered when the NEXT operation is armed — so left raised it made
    // every later arrival at this directory reload a second time on top of the mount's
    // own load. Clearing it here is what turns "once per visit" into "once, ever".
    //
    // The source-side effect below is the only other consumer, and it is deliberately
    // NOT consulted here: consuming only ever happens at the destination, so a user
    // standing at the source when the operation lands still gets their selection
    // cleared (this effect returns above without consuming when the directory does not
    // match).
    //
    // The one case the consume costs something: the user was at the DESTINATION when it
    // completed, then walks back to the source. This component is rendered without a key
    // (ContentManagerBody), so it does not remount on navigation, and Fluent's Selection
    // restores by item key — after a COPY that can leave the original rows still
    // highlighted. Accepted over the alternative, which is reloading the destination a
    // second time on every later visit. After a MOVE the rows are gone, so nothing
    // restores.
    dispatch(setContentManagerMoveTo({ isMoveComplete: false }));
  }, [moveToIsMoveComplete, moveTo.destinationDirectory, currentDirectory]);

  // Retry ONLY while the moved items are genuinely absent, and only so many times.
  //
  // Each reload replaces gridProps, which re-runs this: if the items came with it the
  // pending timer is cancelled by the cleanup before it ever fires. A false negative — a
  // copy renamed by NameConflictBehavior, an item sorted onto a later page — costs one
  // extra reload and then stops, because the retry budget is spent regardless.
  React.useEffect(() => {
    if (pendingArrivalNames.length === 0) {
      return undefined;
    }
    // Arrived, or out of budget: either way stop watching. Clearing the names is what
    // ends the cycle — nothing here reschedules itself.
    if (haveArrived(gridProps?.items, pendingArrivalNames) || arrivalRetriesRef.current >= MAX_ARRIVAL_RETRIES) {
      setPendingArrivalNames([]);
      return undefined;
    }

    const arrivalTimeoutId = setTimeout(() => {
      arrivalRetriesRef.current += 1;
      reloadGrid();
    }, ARRIVAL_RETRY_DELAY_MS);

    return () => clearTimeout(arrivalTimeoutId);
  }, [pendingArrivalNames, gridProps]);

  React.useEffect(() => {
    if (moveToIsMoveComplete && moveTo.sourceDirectory?.id === currentDirectory?.id) {
      setSelectionCleared(true);
    }
  }, [moveToIsMoveComplete, moveTo.sourceDirectory, currentDirectory]);

  React.useEffect(() => {
    detailsListRef?.current?.scrollToIndex(0);
  }, [scrollToTopToggle]);

  React.useEffect(() => {
    if (selectionCleared) {
      clearItemSelection();
      setSelectionCleared(false);
    }
  }, [selectionCleared]);

  React.useEffect(() => {
    if (exchangeProgress && exchangeProgress.status === BackgroundTaskStatusEnum.Completed && !isCMMoveFilesListPanelOpen) {
      dispatch(setContentManagerExchangeProgress(undefined));
    }
    else if (!moveTo.busyFetchingFiles && !moveTo.busyMovingFiles && !isCMMoveFilesListPanelOpen) {
      dispatch(setContentManagerMoveTo({ isMoveInProgress: false }));
    }
  }, [exchangeProgress, isCMMoveFilesListPanelOpen, moveTo.busyFetchingFiles, !moveTo.busyMovingFiles]);

  React.useEffect(() => {
    let loaderTimer: NodeJS.Timeout;
    if (isFetchingData && !(gridProps?.columns?.length > 0)) {
      loaderTimer = setTimeout(() => {
        setShowLoadingSpinner(true);
      }, 500);
    }
    else {
      setShowLoadingSpinner(false);
    }

    return () => {
      clearTimeout(loaderTimer);
    };
  }, [isFetchingData, gridProps?.columns]);

  React.useEffect(() => {
    if (selectedView?.viewType === ViewTypes.TILES) {
      _selection.current.setItems(gridProps?.items ?? [], false);
    }
  }, [selectedView, gridProps?.items]);

  const renderNoResultsFound = React.useCallback((): JSX.Element => {
    return (
      <Stack verticalAlign="center" horizontalAlign="center" styles={noResultsStackStyles}>
        <StackItem align="center">
          <img src={searchIconSrc} />
        </StackItem>
        <StackItem align="center">
          <Label disabled>{languageStrings.NoResultsFound}</Label>
        </StackItem>
      </Stack>
    );
  }, []);

  const onColumnHeaderClicked = (ev?: React.MouseEvent<HTMLElement, MouseEvent>, column?: IGridColumn) => {
    onSortColumn(column, quickFilterValue ? true : false);
  }

  const onRenderHeader = (headerProps: IGroupDividerProps, defaultRender: IRenderFunction<IGroupHeaderProps>) => {
    return (
      <span>
        {defaultRender(
          {
            ...headerProps,
            styles: { headerCount: headerCountStyle }
          })}
      </span>
    );
  }

  const onGroupToggle = (group: IGroup) => {
    if (!group.children && group.count === 0) {
      fetchGroupedDrillDownData(group);
    }
  }

  const _onRenderDetailsFooter = (detailsFooterProps: IDetailsFooterProps): JSX.Element => {
    return !isFetchingData && !preselectSuppressGrid && gridProps?.items.length === 0 && gridProps?.groups.length === 0
      ? renderNoResultsFound()
      : <></>;
  }

  const _onRenderRow: IDetailsListProps['onRenderRow'] = rowProps => {
    return (
      <DraggableContainer
        isValidDropZone={rowProps.item.FSObjType === "1"}
        onDropBeforeFiles={() => setIsFetchingData(true)}
        onDropAfterFiles={(selectedGridItems?: any[]) => onGridItemDrop(rowProps.item, true, selectedGridItems)}
        onDragHover={() => onGridItemDrop(rowProps.item, false)}
        gridItem={rowProps.item}
      >
        <DetailsRow
          {...rowProps}
          styles={rowStyles}
          disabled={rowProps.item[rowLockIndicator] === true}
          className={detailsListClassNames.row}
        />
      </DraggableContainer>
    )
  }

  const _onRenderDetailsHeader: IDetailsListProps['onRenderDetailsHeader'] = props => {
    if (props) {
      const listRef = detailsListRef?.current as any;
      return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
        <DetailsHeader {...props} isAllCollapsed={!listRef?.props?.groups?.some(x => !x.isCollapsed)} />
      </Sticky>;
    }
    return null;
  }

  const onRenderCustomPlaceholder = (rowProps: IDetailsRowProps, index?: number, defaultRender?: (props: IDetailsRowProps) => React.ReactNode) => {
    if (rowProps.item === null) {
      fetchListStreamNextPage();
    }
    return defaultRender(rowProps);
  }

  const onToggleCollapseAll = async (isAllCollapsed: boolean) => {
    if (!isAllCollapsed) {
      const groupingCount = gridProps.groupProps.names.length;
      if (groupingCount === 1) {
        await fetchGroupedDrillDownDataAllGroups();
      }
    }

    isAllCollapsedRef.current = isAllCollapsed;
  }

  const metaDataUpdated = async (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention?: string, replacementFile?: IFileToUpload, closeFileInfoPanel: boolean = true) => {
    itemUpdatedId.current = undefined;
    try {
      if (infoPanelMode === InfoPanelMode.NewTemplate) {
        reloadGrid();
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        setSelectedNewDocumentTemplate(null);
        return;
      }

      if (infoPanelMode === InfoPanelMode.Replace && replacementFile && replacementFile.extension !== extention) {
        reloadGrid();
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        return;
      }

      let serverRelativePath = '';
      if (currentDirectory?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.serverRelativePath) {
        serverRelativePath = currentDirectory?.serverRelativePath;
      }
      else if (currentDirectory?.directory?.length > 0 && currentDirectory?.parentId) {
        let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
        const results = await getItemWebUrl({ driveId, itemId: currentDirectory?.id, accessToken: await authModule.getGraphAccessToken() }).unwrap();
        const resolvedPath = tryGetPathname(results.listItem?.webUrl || results.webUrl);
        serverRelativePath = resolvedPath ? tryDecodeUriComponent(resolvedPath) : currentDirectory?.serverRelativePath ?? "";
      }

      if (closeFileInfoPanel) {
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        setSelectedNewDocumentTemplate(null);
      }

      setShowRenameDialog(false);
      let listStreamByID = await renderListAsStreamByID({
        siteUrl: isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl,
        sharePointListId: currentDirectory?.sharePointListId,
        viewId: selectedView?.Id,
        accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        Id: selectedItem.ID,
        serverRelativePath
      }).unwrap();

      if (listStreamByID.ListData?.Row?.length > 0) {
        const newGridProps = { ...gridProps };

        const newRows = [];
        newGridProps.items.forEach(item => {
          if (item && item.ID === listStreamByID.ListData.Row[0].ID) {
            newRows.push(listStreamByID.ListData.Row[0]);
            setSelectedItem({ ...listStreamByID.ListData.Row[0] });
          } else {
            newRows.push(item);
          }
        });

        setSelectedItems({ items: [listStreamByID.ListData.Row[0]], count: 1 });

        newGridProps.items = [...newRows];
        setGridProps(newGridProps);
      }
      else {
        if (!closeFileInfoPanel) {
          const newRows = [];
          gridProps.items.forEach((item, index) => {
            if (item && item.ID === selectedItem.ID) {
              newRows.push({ ...item, [rowLockIndicator]: true });
            } else {
              newRows.push(item);
            }
          });
          setGridProps({ ...gridProps, items: newRows });
        }
        else {
          reloadGrid();
        }
      }
    } catch (error) {
      logger(error, "ContentBodyFilesFolders.tsx (metaDataUpdated)");
    }
  }

  const onFolderCreated = () => {
    setIsCMCreateFolderPanelOpen(false);
    setSelectedNewDocumentTemplate(null);
    reloadGrid();
  }

  const onDeleteCloseSuccess = (successIds: string[], errors: ItemError[]) => {
    deleteSuccess(successIds)

    if (errors.length > 0) {
      setIsCMErrorModalOpen(true);
      setErrorMessage(buildItemErrorMessage(errors, languageStrings.ErrorDeletingFiles));
    }
  }

  const onCancelAssignmentSuccess = (hasError: boolean) => {
    setShowCancelAssignmentDialog(false)

    if (hasError) {
      setIsCMErrorModalOpen(true);
      setErrorMessage(languageStrings.ErrorDeletingFiles);
    } else {
      reloadGrid();
      setTimeout(() => {
        dispatch(setLastApprovalLoad());
      }, 3000);
    }
  }

  const quickFilterPredicate = React.useCallback((result: any) => {
    if (result === undefined || result === null) {
      // Limit continuous auto paging to a max of 300 items
      return gridProps?.items?.length > 1 && gridProps.items.length < 300;
    }
    else {
      const resultProperties = Object.keys(result);
      return resultProperties.some(property => {
        return quickFilterPropValPredicate(result, property);
      });
    }
  }, [gridProps, filterFields, quickFilterValue]);

  const quickFilterPropValPredicate = React.useCallback((result: any, property: any) => {
    try {
      const propertyField: any = filterFields?.find(field => field.RealFieldName?.toLowerCase() === property.toLowerCase());
      const propertyType: string = propertyField?.FieldType ?? propertyField?.Type;
      let propertyValue: string;
      if (propertyType) {
        switch (propertyType) {
          case "DateTime":
          case "DateOnly":
            propertyValue = result[property] ? dayjs(result[property]).utc().local().format("L LT")?.toLowerCase() : null;
            break;

          case "User":
          case "UserMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.title?.toLowerCase())?.join(";") : null;
            break;

          case "TaxonomyFieldType":
            propertyValue = result[property]?.Label?.toLowerCase();
            break;

          case "TaxonomyFieldTypeMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.Label?.toLowerCase())?.join(";") : null;
            break;

          case "MultiChoice":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.toString()?.toLowerCase())?.join(";") : null;
            break;

          case "LookupMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.lookupValue?.toLowerCase())?.join(";") : null;
            break;

          default:
            propertyValue = result[property]?.toString().toLowerCase();
            break;
        }
      }
      return propertyValue?.includes(quickFilterValue.toLowerCase());
    } catch (error) {
      // Do not log to generic logger as it may flood the db.
      console.error(error);
    }
    return true;
  }, [filterFields, quickFilterValue]);

  const viewItems = React.useMemo(() => {
    if (gridProps?.items?.length > 0) {
      return quickFilterValue
        ? gridProps.items.filter(quickFilterPredicate)
        : gridProps.items;
    }
    return [];
  }, [gridProps?.items, quickFilterPredicate, quickFilterValue]);

  const folderViewItems = React.useMemo(() => viewItems.filter(item => item?.FSObjType === "1"), [viewItems]);
  const fileViewItems = React.useMemo(() => viewItems.filter(item => item && item.FSObjType !== "1"), [viewItems]);
  const selectedItemIds = React.useMemo(() => new Set(selectedItems?.items?.map(item => item?.ID)), [selectedItems?.items]);

  React.useEffect(() => {
    if (!gridProps?.items) {
      return;
    }

    const validIds = new Set(gridProps.items.filter(item => item).map(item => item.ID));
    const hasStaleSelection = selectedItems.items?.some(item => item && !validIds.has(item.ID));
    if (!hasStaleSelection) {
      return;
    }

    const nextSelectedItems = selectedItems.items.filter(item => item && validIds.has(item.ID));
    setSelectedItems({ items: nextSelectedItems, count: nextSelectedItems.length });

    if (nextSelectedItems.length === 1) {
      const nextSelectedItem = nextSelectedItems[0];
      setSelectedItem(nextSelectedItem);
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(nextSelectedItem.ProgId === OneNoteProgId ? OneNoteProgId : nextSelectedItem[".fileType"]));
    } else {
      setSelectedItem(null);
      setSelectedItemInfo(null);
    }
  }, [gridProps?.items, selectedItems.items]);

  const onConfirmMoveFiles = async (isSaving: boolean) => {
    if (!isSaving) {
      let progressCountTotal = moveTo.selectedFiles ? moveTo.selectedFiles.length : 0;
      if (moveToMode === ContentManagerCopyMoveModeEnum.CopyAll || moveToMode === ContentManagerCopyMoveModeEnum.MoveAll) {
        if (folderPath?.length === 0) {
          const settings = await getListSettings(isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(), moveTo.sourceSiteUrl, currentDirectory.sharePointListId);
          progressCountTotal = settings.ItemCount;
        } else {
          progressCountTotal = gridProps?.items?.length
        }
      }

      dispatch(setContentManagerMoveTo({
        moveToEnabled: true,
        sourceServerRelPath: serverRelPath,
        // Every library-initiated copy/move (CopyTo, MoveTo, CopyAll, MoveAll) arms
        // here, and this is the only place a real source path is established. Clearing
        // the aggregate view's display label here — rather than at each of those four
        // call sites — is what stops "All Documents" from outliving that operation and
        // mislabelling the source of the next one.
        sourceDisplayName: "",
        progressCountTotal
      }));
      setShowConfirmMoveToDialog(false);
    }
    else if (moveToMode === ContentManagerCopyMoveModeEnum.CopyAll || moveToMode === ContentManagerCopyMoveModeEnum.MoveAll) {
      const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;

      dispatch(setContentManagerMoveTo({
        siteUrl,
        isMoveInProgress: true,
        busyFetchingFiles: true,
        destinationServerRelPath: serverRelPath,
        destinationDirectory: currentDirectory
      }));
      setShowConfirmMoveToDialog(false);
      dispatch(setContentManagerMoveToSelectedFilesIsBusyProgress([], true));
      setIsCMMoveFilesListPanelOpen(true);
    }
    else {
      try {
        const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;

        setIsBusyCreatingMoveToJobQue(true); //Confirm move to modal spinner
        // Clear any error from a previous attempt: the reducer only overwrites `error`
        // when a value is supplied, so a stale one would outlive a successful retry.
        dispatch(setContentManagerMoveToError(""));
        const copyRequest = {
          siteUrl,
          accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
          files: moveTo.selectedFiles,
          sourceSiteUrl: moveTo.sourceSiteUrl,
          destinationServerRelPath: serverRelPath,
          isMoveMode: (moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? true : false
        }

        let copyJobResults = await createCopyJobs(copyRequest);
        if (copyJobResults?.success) {
          dispatch(setContentManagerMoveToSelectedFilesIsBusyProgress([], true));
          dispatch(setContentManagerMoveTo({
            siteUrl,
            busyMovingFiles: true,
            isMoveInProgress: true,
            moveToEnabled: false,
            destinationDirectory: currentDirectory
          }));
          dispatch(setContentManagerMoveToCopyJobResults(copyJobResults?.jobs))

          setIsCMMoveFilesListPanelOpen(true);
        }
        else {
          // Keep the queue and stay in destination-picking mode so the user can retry
          // at another destination instead of reselecting everything.
          dispatch(setContentManagerMoveTo(buildCopyMoveFailureUpdate(copyJobResults.error)));
        }

        setIsBusyCreatingMoveToJobQue(false);
        setShowConfirmMoveToDialog(false);

      } catch (error) {
        setIsBusyCreatingMoveToJobQue(false);
        setShowConfirmMoveToDialog(false);
        setIsCMErrorModalOpen(true);
        // Not every throw here is an OData response — a token acquisition failure has
        // no `.data` at all, and the unguarded walk used to throw a second time inside
        // the handler, losing the error entirely.
        setErrorMessage(error?.data?.["odata.error"]?.message?.value ?? languageStrings.ErrorMessageGeneric);
        // The queue survives; only the in-flight flags need standing down.
        dispatch(setContentManagerMoveTo(buildCopyMoveFailureUpdate(undefined)));

        logger(error, "ContentBodyFilesFolders.tsx (onConfirmMoveFiles (else))");
      }
    }
  }

  // The copy/move tray is mounted above every body view so it survives navigation, but
  // the confirm dialog is owned here. It signals through redux; consume the flag once
  // and clear it immediately so a later render cannot reopen the dialog.
  React.useEffect(() => {
    if (moveTo.commitRequested) {
      dispatch(setContentManagerMoveTo({ commitRequested: false }));

      // Drop any error from a previous attempt as this one opens, so the tray does not
      // show a stale failure over a live confirmation.
      dispatch(setContentManagerMoveToError(""));
      setShowConfirmMoveToDialog(true);
    }
  }, [moveTo.commitRequested]);

  // A copy/move failure belongs to the destination it happened at. Once the user goes
  // somewhere else to retry, the tray must stop showing it — a red banner beside a
  // now-enabled Confirm button reads as "this destination is broken too".
  //
  // Keyed on the directory ALONE, with the values read through a ref: putting
  // moveToEnabled in the deps would erase the message it is meant to preserve, because
  // buildCopyMoveFailureUpdate raises moveToEnabled and sets the error in a SINGLE
  // action — the effect would fire on that same change and clear it immediately.
  const moveToRef = React.useRef(moveTo);
  moveToRef.current = moveTo;

  React.useEffect(() => {
    if (moveToRef.current.moveToEnabled && moveToRef.current.error) {
      dispatch(setContentManagerMoveToError(""));
    }
    // Whatever we were waiting to see arrive belonged to the directory we just left —
    // left set, it would spend its retry reloading THIS one looking for items that were
    // never coming here.
    setPendingArrivalNames([]);
  }, [currentDirectory?.id]);

  // Tell the tray whether THIS directory already holds some of the queued items, so it
  // can disable its commit rather than let the user confirm a move CreateCopyJobs will
  // reject. The tray cannot work this out: it is mounted above this component and sees
  // neither the resolved destination path nor a row's real source folder (its own
  // same-source guard compares against moveTo.workingDirectories, which for an aggregate
  // selection is the site).
  //
  // Gated on moveToEnabled so it costs nothing outside destination-picking — and so the
  // per-tick selectedFiles churn during a running job never reaches the path scan.
  //
  // "unresolved" while serverRelPath is empty is the load-bearing part: that field is
  // cleared on EVERY directory change and only repopulated when the new directory's list
  // stream settles. Reporting "clear" in the meantime would enable the commit against
  // the folder the user just left. Entering a library from the locations list is covered
  // by isContentLoading, but walking into a SUBFOLDER is not — nothing else guards that.
  React.useEffect(() => {
    const isMoveOperation = moveToMode === ContentManagerCopyMoveModeEnum.Move
      || moveToMode === ContentManagerCopyMoveModeEnum.MoveAll;

    let destinationMoveCheck: ContentManagerDestinationMoveCheck;
    if (!moveToEnabled || !isMoveOperation) {
      destinationMoveCheck = "clear";
    } else if (!serverRelPath) {
      destinationMoveCheck = "unresolved";
    } else {
      destinationMoveCheck = destinationHoldsQueuedRows(serverRelPath, moveTo.selectedFiles)
        ? "holdsQueuedItems"
        : "clear";
    }

    if (destinationMoveCheck !== moveTo.destinationMoveCheck) {
      dispatch(setContentManagerMoveTo({ destinationMoveCheck }));
    }
  }, [moveToEnabled, moveToMode, serverRelPath, moveTo.selectedFiles, moveTo.destinationMoveCheck]);

  React.useEffect(() => {
    if (showConfirmMoveToDialog) {
      let confirmMessage = (moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll)
        ? languageStrings.SelectDestinationDirectoryConfirmMove
        : languageStrings.SelectDestinationDirectoryConfirmCopy

      const partsAmountSplit = confirmMessage.split("{amount}");
      const partsSourceSplit = partsAmountSplit[1].split("{source}");

      let amountStr = (moveTo.mode === ContentManagerCopyMoveModeEnum.CopyAll || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll)
        ? languageStrings.All.toLowerCase()
        : moveTo.selectedFiles?.length?.toString();

      const sourceStr = moveToSourceDisplayName ? moveToSourceDisplayName : moveToSourceServerRelPath;

      setHtmlConfirmMessage(<div style={{ wordWrap: "break-word" }}>{partsAmountSplit[0]}<b>{amountStr}</b>{partsSourceSplit[0]}<b>{sourceStr}</b>{partsSourceSplit[1]}</div>);
    }
  }, [showConfirmMoveToDialog, moveToSourceServerRelPath, moveToSourceDisplayName, moveTo.mode, moveTo.selectedFiles, languageStrings]);

  const onGridDrop = React.useCallback(async () => {
    if (DragAndDropHelper.mode === DragMode.gridItems && DragAndDropHelper.selectedGridItems?.length > 0) {
      let serverRelativePath: string = serverRelPath ? serverRelPath : currentDirectory?.serverRelativePath;
      if (!serverRelativePath && currentDirectory?.directory?.length > 0 && currentDirectory?.id) {
        const driveId = isInOneDrive.current && oneDriveRootDetails ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
        const webUrl = await getListItemWebUrl(await authModule.getGraphAccessToken(), driveId, currentDirectory.parentId ? currentDirectory.id : null);
        if (webUrl) {
          serverRelativePath = tryDecodeUriComponent(new URL(webUrl).pathname);
        }
      }
      const siteUrl = isInOneDrive.current && oneDriveRootDetails ? oneDriveRootDetails.sharePointSiteUrl : currentDirectory?.webUrl;
      DragAndDropHelper.handleGridMove(dispatch, siteUrl, workingDirectories, isInOneDrive.current, serverRelativePath);
    } else if (DragAndDropHelper.mode === DragMode.files) {
      setIsCMUploadFilesPanelOpen(true);
    }
  }, [oneDriveRootDetails, currentDirectory, workingDirectories, serverRelPath]);

  const onGridItemDrop = React.useCallback(async (item, hasDropContent: boolean = true, selectedGridItems?: any[]) => {
    try {
      let itemid = "";
      let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);

      const spItemUrlparts = item['.spItemUrl']?.split('/');
      if (spItemUrlparts) {
        itemid = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
      }

      const siteUrlPath: string = new URL(currentDirectory.webUrl)?.pathname + "/";

      const itemToAdd: IPageSettings = {
        id: itemid,
        parentId: driveId,
        type: isInOneDrive.current ? ComponentTypes.OneDrive : ComponentTypes.SharePointFolders,
        siteId: currentDirectory.siteId,
        siteDisplayName: currentDirectory.siteDisplayName,
        webUrl: currentDirectory.webUrl,
        fileTitle: item.FileLeafRef,
        directory: item.FileRef.replace(siteUrlPath, ""),
        DocumentLibrary: currentDirectory.DocumentLibrary,
        displayName: item.FileLeafRef,
        isTeamsFolder: currentDirectory.isTeamsFolder,
        sharePointListId: currentDirectory.sharePointListId,
        contentTypeId: item.ContentTypeId,
        serverRelativePath: item.FileRef,
        sharePointUniqueId: item.UniqueId?.replace("{", "").replace("}", "")
      };

      if (DragAndDropHelper.mode === DragMode.files || !hasDropContent) {
        dispatch(addWorkingDirectory(itemToAdd));
        dispatch(setContentManagerSearchValue(""));
        dispatch(toggleContentManagerReload());
        setIsFetchingData(false);
      }

      if (hasDropContent) {
        if (DragAndDropHelper.mode === DragMode.gridItems && selectedGridItems?.length > 0) {
          const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;
          DragAndDropHelper.destinationDirectory = itemToAdd;
          DragAndDropHelper.handleGridMove(dispatch, siteUrl, workingDirectories, isInOneDrive?.current);
        }
        else if (DragAndDropHelper.mode === DragMode.files) {
          setIsCMUploadFilesPanelOpen(true);
        }
      }
    } catch (error) {
      logger(error, "ContentBodyFilesFolders.tsx (onGridItemDrop)");
    }
  }, [oneDriveRootDetails, currentDirectory, workingDirectories]);

  const dragDropEvents = React.useMemo(() => ({
    canDrop: (dropContext?: IDragDropContext, dragContext?: IDragDropContext) => {
      return true;
    },
    canDrag: (item?: any) => {
      return !moveTo.busyMovingFiles;
    },
    onDragStart: (item?: any, itemIndex?: number, selectedItems?: any[], event?: DragEvent) => {
      let selectedGridItems: any[] = selectedItems?.filter(selectedItem => selectedItem);
      if (!Array.isArray(selectedGridItems)) {
        selectedGridItems = [];
      }
      // Whether the dragged row is in the selection Fluent passed in, before the move path adds it.
      const wasDraggedRowSelected: boolean = !!item && selectedGridItems.some(selectedItem => selectedItem.ID === item.ID);

      if (gridProps?.items?.length > 0
        && item
        && (selectedGridItems.length === 0 || selectedGridItems.findIndex(selectedItem => selectedItem.ID === item.ID) === -1)) {
        const draggedItemIndex: number = gridProps.items.findIndex(x => x.ID === item.ID);
        if (draggedItemIndex > -1) {
          // The grid shows only this row selected from here on, so the move carries it alone.
          selectedGridItems = [item];
          _selection.current.setAllSelected(false);
          _selection.current.setIndexSelected(draggedItemIndex, true, true);
        }
      }

      if (selectedGridItems?.length > 0) {
        event.dataTransfer.setData(DragAndDropHelper.gridDataTransferType, JSON.stringify(selectedGridItems));

        DragAndDropHelper.mode = DragMode.gridItems;
        DragAndDropHelper.sourceDirectory = currentDirectory;
        DragAndDropHelper.destinationDirectory = currentDirectory;
        DragAndDropHelper.sourceServerRelPath = serverRelPath;
        DragAndDropHelper.selectedGridItems = selectedGridItems.filter(selectedItem => selectedItem);
      }

      // The dragged rows, for the Copilot pane's drop target (spec 2026-10-22 §2.5): a drag's data
      // can't be read before its drop. A SharePoint list (no place) has no files to ask about. A row
      // dragged by its name cell (data-selection-disabled) arrives with the old selection, and the grid
      // then shows only that row selected: Copilot gets that row alone (final review of plan 2b, I3).
      const copilotRows: any[] = item && !wasDraggedRowSelected ? [item] : selectedGridItems;
      setCopilotDragSource(copilotPlace && copilotRows.length > 0 ? { rows: copilotRows, place: copilotPlace } : null);
    },
    onDragEnd: () => {
      setCopilotDragSource(null);
    }
  }), [currentDirectory, moveTo.busyMovingFiles, serverRelPath, gridProps?.items, copilotPlace]);

  const getSelectedIndex = React.useCallback(() => {
    const selectedIndices: number[] = _selection.current?.getSelectedIndices();
    if (Array.isArray(selectedIndices) && selectedIndices.length > 0 && gridProps?.items?.length > 0) {
      return selectedIndices[0];
    }
    return -1;
  }, [gridProps?.items]);

  const getIsMoveBackDisabled = React.useCallback(() => {
    let isMoveBackDisabled: boolean = true;
    const selectedIndex: number = getSelectedIndex();
    if (selectedIndex >= 1) {
      const prevItem = gridProps.items[selectedIndex - 1];
      if (prevItem && prevItem[rowLockIndicator] !== true) {
        isMoveBackDisabled = false;
      }
    }
    return isMoveBackDisabled;
  }, [gridProps?.items]);

  const getIsMoveForwardDisabled = React.useCallback(() => {
    let isMoveForwardDisabled: boolean = true;
    const selectedIndex: number = getSelectedIndex();
    if (selectedIndex !== -1 && selectedIndex < gridProps.items.length) {
      const nextItem = gridProps.items[selectedIndex + 1];
      if (nextItem && nextItem[rowLockIndicator] !== true) {
        isMoveForwardDisabled = false;
      }
    }
    return isMoveForwardDisabled;
  }, [gridProps?.items]);

  const move = React.useCallback((direction: MoveDirection) => {
    const currentSelectedIndex: number = getSelectedIndex();
    if (currentSelectedIndex !== -1) {
      let nextSelectedIndex: number;
      if (direction === MoveDirection.Back) {
        nextSelectedIndex = currentSelectedIndex - 1;
      }
      else {
        nextSelectedIndex = currentSelectedIndex + 1;
      }

      if ((gridProps.items.length - 1) >= nextSelectedIndex) {
        _selection.current.setAllSelected(false);
        _selection.current.setIndexSelected(nextSelectedIndex, true, true);
        detailsListRef.current?.focusIndex(nextSelectedIndex);
      }
    }
  }, [gridProps?.items]);

  const getIsPreviewNotSupported: boolean = React.useMemo(() => {
    try {
      return (!selectedItem?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.document) || selectedItem?.ProgId === OneNoteProgId) === true;
    } catch (error) {
      // ignore
    }
    return false;
  }, [selectedItem]);

  const handleScroll = React.useCallback(async (event: React.UIEvent<HTMLElement>) => {
    if (gridProps?.hasMoreResults) {
      const el = event.target as HTMLDivElement;
      const bottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 300;
      if (bottom && !isLoadingNextPage) {
        setIsLoadingNextPage(true);
        await fetchListStreamNextPage();
        setIsLoadingNextPage(false);
      }
    }
  }, [isLoadingNextPage, gridProps?.hasMoreResults, fetchListStreamNextPage]);

  const onTileSelect = React.useCallback((item: any) => {
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), true, true);
    setSelectedItems({ items: [item], count: 1 });
    setSelectedItem({ ...item });
    setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(item.ProgId === OneNoteProgId ? OneNoteProgId : item[".fileType"]));
    showFileInfo();
  }, [gridProps?.items]);

  const onTileCheck = React.useCallback((item: any, checked: boolean) => {
    let updatedSelectedItems = selectedItems
      ? { items: [...(selectedItems.items ?? [])], count: (selectedItems.items?.length ?? 0) }
      : { items: [], count: 0 };

    if (checked) {
      updatedSelectedItems = { items: [...updatedSelectedItems.items, item], count: updatedSelectedItems.items.length + 1 };
    }
    else {
      updatedSelectedItems = { items: updatedSelectedItems.items.filter(selectedItem => selectedItem?.ID !== item?.ID), count: updatedSelectedItems.items.length > 0 ? updatedSelectedItems.items.length - 1 : 0 };
    }

    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), checked, checked);

    if (updatedSelectedItems.items.length === 1) {
      const newSelectedItem: any = updatedSelectedItems.items[0];
      setSelectedItem(newSelectedItem);
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(newSelectedItem.ProgId === OneNoteProgId ? OneNoteProgId : newSelectedItem[".fileType"]));
    }
    else {
      setSelectedItem(null);
      setSelectedItemInfo(null);
    }
    setSelectedItems(updatedSelectedItems);
  }, [selectedItems, gridProps?.items]);

  const onTileContextMenu = React.useCallback((ev: any, item: any) => {
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), true, true);
    setSelectedItems({ items: [item], count: 1 });
    setSelectedItem({ ...item });
    triggerContextMenu(ev);
  }, [gridProps?.items]);

  const isDetailTile = React.useMemo(() => selectedView?.viewType === ViewTypes.TILES && selectedView?.tileDisplayFields?.length > 0, [selectedView]);

  return (
    <>
      <input ref={fileInputRef} type="file" id="fileElem" multiple onChange={handleSelectedFiles} style={{ display: "none" }}></input>
      {/* @ts-expect-error */}
      <input ref={folderInputRef} type="file" id="folderElem" directory="" webkitdirectory="" multiple onChange={handleSelectedFiles} style={{ display: "none" }}></input>
      <ContentBodyCommandBar commandBarMenu={commandBarMenu} />
      <div className={detailsListClassNames.viewport}>
      <UnfilledPlaceholdersMessageBar placeholders={unfilledPlaceholders} unusedValues={unusedCustomValues} columnPlaceholders={unfilledColumnPlaceholders} crmResolutionReasons={crmResolutionReasons} onDismiss={dismissUnfilledPlaceholders} />
      <ScanErrorsMessageBar errors={scanCustomFieldsErrors} skipped={scanCustomFieldsSkipped} onDismiss={dismissScanCustomFieldsErrors} />
      {showLoadingSpinner
        ? <Stack verticalAlign="center" horizontalAlign="center" styles={loadingSpinnerStackStyles}><Spinner size={SpinnerSize.large} /></Stack>
        : <div className={detailsListClassNames.wrapper} ref={renameShortcutGridRef}>
          <DraggableContainer isValidDropZone={!isSharePointList} onDropAfterFiles={onGridDrop} isGrid={true}>
            {selectedView?.viewType === ViewTypes.TILES
              ? <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto} onScroll={handleScroll} styles={{ contentContainer: { paddingTop: 25, paddingBottom: 25, paddingLeft: 5, paddingRight: 5, overflowX: "hidden" } }}>
                {!isDetailTile && folderViewItems.length > 0 && <Stack horizontal wrap tokens={{ childrenGap: 15 }} styles={{ root: { paddingBottom: 15 } }} >
                  {folderViewItems
                    .map((item, index) => {
                      return <ViewTile
                        key={`${item?.UniqueId}${index}`}
                        isSharePointList={isSharePointList}
                        viewItem={item}
                        isSelected={item && selectedItemIds.has(item.ID)}
                        isDetailTile={isDetailTile}
                        onTileSelect={onFolderClick}
                        onTileCheck={onTileCheck}
                        onTileContextMenu={onTileContextMenu}
                        getTimeZoneFormattedDate={getTimeZoneFormattedDate}
                      />
                    })}
                </Stack>}
                <Stack horizontal wrap tokens={{ childrenGap: 15 }} >
                  {(isDetailTile ? viewItems.filter(item => item) : fileViewItems)
                    .map((item, index) => {
                      return <ViewTile
                        key={`${item?.UniqueId}${index}`}
                        isSharePointList={isSharePointList}
                        viewItem={item}
                        isSelected={item && selectedItemIds.has(item.ID)}
                        isDetailTile={isDetailTile}
                        tileDisplayFields={selectedView?.tileDisplayFields}
                        listHttpRoot={listHttpRoot}
                        onTileSelect={item?.FSObjType === "1" ? onFolderClick : onTileSelect}
                        onTileCheck={onTileCheck}
                        onTileContextMenu={onTileContextMenu}
                        getTimeZoneFormattedDate={getTimeZoneFormattedDate}
                        openExternalResourceUrl={openExternalResourceUrl}
                      />
                    })}
                  {!isFetchingData && !preselectSuppressGrid && viewItems.length === 0 && (gridProps?.groups?.length ?? 0) === 0 && renderNoResultsFound()}
                </Stack>
                {isLoadingNextPage && <Spinner size={SpinnerSize.large} styles={{ root: { padding: 25 } }} />}
              </ScrollablePane>
              : <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                <MarqueeSelection isEnabled={isMarqueeEnabled} selection={_selection.current}>
                  <ShimmeredDetailsList
                    componentRef={detailsListRef}
                    detailsListStyles={detailListStyles}
                    onRenderRow={_onRenderRow}
                    compact={false}
                    items={viewItems}
                    focusZoneProps={{
                      elementRef: focusZoneRef
                    }}
                    columns={gridProps?.columns?.length > 0 ? gridProps.columns : []}
                    onRenderDetailsHeader={_onRenderDetailsHeader}
                    selectionMode={!moveToEnabled ? SelectionMode.multiple : SelectionMode.none}
                    constrainMode={ConstrainMode.unconstrained}
                    onColumnHeaderClick={onColumnHeaderClicked}
                    onItemInvoked={showFileInfo}
                    setKey="multiple"
                    enableShimmer={isFetchingData || preselectSuppressGrid}
                    dragDropEvents={dragDropEvents}
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    selectionPreservedOnEmptyClick={true}
                    selection={_selection.current}
                    ariaLabelForSelectionColumn="Toggle selection"
                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                    checkButtonAriaLabel="Row checkbox"
                    onItemContextMenu={(item?: any, index?: number, ev?: MouseEvent) => {
                      if (!item[rowLockIndicator]) {
                        triggerContextMenu(ev);
                      }
                    }}
                    groupProps={{
                      showEmptyGroups: true,
                      onRenderHeader,
                      headerProps: {
                        onToggleCollapse: onGroupToggle
                      },
                      onToggleCollapseAll
                    }}
                    onRenderDetailsFooter={_onRenderDetailsFooter}
                    groups={!isFetchingData && gridProps?.groups?.length > 0 && !quickFilterValue ? gridProps?.groups : null}
                    onRenderCustomPlaceholder={onRenderCustomPlaceholder}
                  />
                </MarqueeSelection>
              </ScrollablePane>}
          </DraggableContainer>
          {openContextMenu.open && <ContextualMenu target={openContextMenu.position} directionalHint={DirectionalHint.rightTopEdge} directionalHintFixed={true} items={contextMenu} onDismiss={() => { setOpenContextMenu({ open: false, position: null }); }} />}
        </div>
      }
      </div>
      {suggestPlaceholdersTarget && (
        <CMPlaceholderSuggestPanel
          isOpen={true}
          closePanel={() => setSuggestPlaceholdersTarget(undefined)}
          templateUniqueId={suggestPlaceholdersTarget.templateUniqueId}
          templateFileName={suggestPlaceholdersTarget.templateFileName}
          siteUrl={suggestPlaceholdersTarget.siteUrl}
          listId={suggestPlaceholdersTarget.listId}
          onApplied={(scanErrors) => {
            setScanCustomFieldsErrors(scanErrors ?? [], []);
            // updateGridItems, not reloadGrid: this re-fetches the one row through the current
            // view - Modified, Editor and the Custom fields column the post-apply scan wrote -
            // instead of re-paging the library and losing the user's scroll position. It runs
            // BEFORE closePanel clears the target, which is why the panel reports first.
            if (suggestPlaceholdersTarget?.gridItem) updateGridItems([suggestPlaceholdersTarget.gridItem]);
          }}
        />
      )}
      {/* Grid-level toasts (scan menu): panel ToastContainers only exist while a panel is
          mounted, so menu-triggered toasts would silently queue until one opened. Scoped
          via containerId so panel toasts never render here twice. */}
      <ToastContainer enableMultiContainer containerId={CM_BODY_TOAST_CONTAINER_ID} autoClose={5000} hideProgressBar transition={Slide} />
      {showVersionHistoryDialog && <CMVersionHistoryModal showDialog={showVersionHistoryDialog} closeDialog={() => setShowVersionHistoryDialog(false)} selectedItem={selectedItem} isInOneDrive={isInOneDrive.current} />}
      {showDuplicateFileVersionSelectorModal && <CMDuplicateFileVersionSelectorModal showDialog={showDuplicateFileVersionSelectorModal} closeDialog={() => { setShowDuplicateFileVersionSelectorModal(false); setWaitFor(false); }} closeOnSuccess={() => { setShowDuplicateFileVersionSelectorModal(false); reloadGrid(); setWaitFor(false); }} selectedItem={selectedItem} isDuplicate={pdfConvertIsDuplicate} showSelectVersion={pdfConvertShowVersion} />}
      {showCheckinDialog && <CMCheckinModal showDialog={showCheckinDialog} isPublish={isPublish} closeDialog={() => setShowCheckinDialog(false)} closeOnSuccess={() => { updateGridItems(selectedItems.items); setShowCheckinDialog(false) }} selectedItems={selectedItems.items} isInOneDrive={isInOneDrive.current} />}
      {isCMVersionAppRejModalOpen && <CMVersionAppRejModal showDialog={isCMVersionAppRejModalOpen} closeDialog={() => setIsCMVersionAppRejModalOpen(false)} closeOnSuccess={() => { updateGridItems(selectedItems.items); setIsCMVersionAppRejModalOpen(false) }} selectedItems={selectedItems.items} isInOneDrive={isInOneDrive.current} />}
      {isApprovalsPanelOpen && <WebPanel isOpen={isApprovalsPanelOpen} closePanel={() => setIsApprovalsPanelOpen(false)} headerText={languageStrings.AutomationFlowRequest} styles={{ main: { overflow: "unset" } }}>
        <AutomationPanel
          files={approvalFiles}
          isGraphQuery={true}
          tenantEnablePII={tenantEnablePII}
          closeClicked={() => setIsApprovalsPanelOpen(false)}
          tenantGuid={userAccount.tenantId}
          requestor={userAccount.username}
          isContentManager={true}
          listName={listTitle}
          locationDirectory={automationAtLocation ? currentDirectory : undefined}
          locationServerRelativeUrl={serverRelPath}
          isSharePointList={isSharePointList}
        />
      </WebPanel>}
      {isSigninPanelOpen && <WebPanel isOpen={isSigninPanelOpen} closePanel={() => setIsSigningPanelOpen(false)} headerText={languageStrings.SigningRequest} styles={{ main: { overflow: "unset" } }}>
        <SigningPanel
          files={approvalFiles}
          tenantEnablePII={tenantEnablePII}
          closeClicked={() => setIsSigningPanelOpen(false)}
          tenantGuid={userAccount.tenantId}
          requestor={userAccount.username}
          isContentManager={true}
          listName={listTitle}
        />
      </WebPanel>}
      {isCMFilePreviewPanelOpen && <WebPanel isOpen={isCMFilePreviewPanelOpen} width="1100px" closePanel={() => setIsCMFilePreviewPanelOpen(false)} headerText={previewTargetName ?? selectedItem?.FileLeafRef} styles={previewWebPanelStyles}>
        {selectedItem && <CMFilePreviewPanel
          selectedItem={selectedItem}
          searchSource={SearchSource.Sharepoint}
          isInOneDrive={isInOneDrive.current}
          totalItemCount={gridProps?.items?.length}
          selectedItemIndex={getSelectedIndex()}
          previewNotSupported={getIsPreviewNotSupported}
          move={move}
          onTargetResolved={setPreviewTargetName}
        />}
      </WebPanel>}
      {externalResourceUrl && <WebPanel isOpen={true} width="1100px" closePanel={() => setExternalResourceUrl(null)} headerText={externalResourceUrl.description} styles={previewWebPanelStyles}>
        <div style={{ height: "calc(100vh - 80px)", width: "100%", marginTop: 5 }}>
          <iframe style={{ height: "100%", width: "100%", border: "none", overflow: "hidden" }} src={externalResourceUrl.url} />
        </div>
      </WebPanel>}
      {showRenameDialog && <CMRenameModal showDialog={showRenameDialog} closeDialog={() => setShowRenameDialog(false)} selectedItem={selectedItem} closeOnSuccess={() => metaDataUpdated(null, null, null)} />}
      {isCMFileInfoPanelOpen && (selectedItem || selectedNewDocumentTemplate) &&
        <CMFileInfoPanel
          // panelIsOpen={isCMFileInfoPanelOpen && (selectedItem || selectedNewDocumentTemplate)}
          panelIsOpen={isCMFileInfoPanelOpen}
          closeOnSuccess={metaDataUpdated}
          closePanel={() => { setIsCMFileInfoPanelOpen(false); setSelectedNewDocumentTemplate(null); }}
          item={selectedItem}
          infoPanelMode={infoPanelMode}
          selectedTemplate={selectedNewDocumentTemplate}
          onCreateFromTemplateWarnings={handleCreateFromTemplateWarnings}
          folderPath={folderPath}
          userPermissions={selectedItem?.EffectiveBasePermissions}
          onItemUpdated={() => itemUpdatedId.current = selectedItem?.ID}
          filePreview={!hideAutoPreview
            && selectedItem
            && !getIsPreviewNotSupported
            && infoPanelMode === InfoPanelMode.Update
            && <CMFilePreviewPanel
              selectedItem={selectedItem}
              searchSource={SearchSource.Sharepoint}
              isInOneDrive={isInOneDrive.current}
              totalItemCount={gridProps?.items?.length}
              selectedItemIndex={getSelectedIndex()}
              previewNotSupported={getIsPreviewNotSupported}
              isPropertiesPreview
              isMoveBackDisabled={getIsMoveBackDisabled()}
              isMoveForwardDisabled={getIsMoveForwardDisabled()}
              move={async (direction: MoveDirection) => {
                if (itemUpdatedId.current === selectedItem?.ID) {
                  await metaDataUpdated(null, null, null, null, null, false);
                }
                else {
                  itemUpdatedId.current = undefined;
                }
                move(direction);
              }}
            />}
        />}
      {!isInOneDrive.current && isCMFileInfoPanelOpen && (selectedItems?.items?.length > 1) && <CMFilesUpdatePanel panelIsOpen={isCMFileInfoPanelOpen && (selectedItems?.items?.length > 1)} closePanel={() => setIsCMFileInfoPanelOpen(false)} reloadGrid={reloadGrid} selectedItems={selectedItems?.items} />}
      {isCMCreateFolderPanelOpen && <NewFolderPanel isOpen={isCMCreateFolderPanelOpen} selectedTemplate={selectedNewDocumentTemplate} dismissNewFolderPanel={() => { setIsCMCreateFolderPanelOpen(false); setSelectedNewDocumentTemplate(null); }} onFolderCreated={onFolderCreated} serverRelPath={serverRelPath} />}
      {isCMCreateLinkPanelOpen && <CMNewLinkPanel panelIsOpen={isCMCreateLinkPanelOpen} closePanel={() => { setIsCMCreateLinkPanelOpen(false); }} reloadGrid={reloadGrid} serverRelPath={serverRelPath} />}
      {isCMUploadFilesPanelOpen && <CMUploadFilesPanel panelIsOpen={isCMUploadFilesPanelOpen} closePanel={() => { setIsCMUploadFilesPanelOpen(false); DragAndDropHelper.reset(); }} reloadGrid={reloadGrid} serverRelPath={serverRelPath} />}
      {isCMFileFilterPanelOpen && <CMFileFilterPanel panelIsOpen={isCMFileFilterPanelOpen} closePanel={() => setIsCMFileFilterPanelOpen(false)} isInOneDrive={isInOneDrive.current} serverRelPath={serverRelPath} selectedView={selectedView} />}
      {isCMFileSharePanelOpen && <CMFileSharePanel panelIsOpen={isCMFileSharePanelOpen} closePanel={() => setIsCMFileSharePanelOpen(false)} items={sharePanelModeRef.current === SharePanelMode.Share ? [selectedItem] : selectedItems?.items} mode={sharePanelModeRef.current} />}
      {isCMShareWithGroupPanelOpen && <CMShareWithGroupPanel panelIsOpen={isCMShareWithGroupPanelOpen} closePanel={() => setIsCMShareWithGroupPanelOpen(false)} groups={clientGroupShareGroups} seeds={(selectedItems?.items ?? []).map(item => ({ name: item?.FileLeafRef ?? "", fileType: item?.[".fileType"] }))} resolveSources={resolveShareWithGroupSources} />}
      {isHixPanelOpen && <HixUploadPanel
        isOpen={isHixPanelOpen}
        onDismiss={() => setIsHixPanelOpen(false)}
        siteDisplayName={currentDirectory?.siteDisplayName}
        files={(selectedItems?.items ?? []).filter(isCmUploadableFile).map((item) => ({ name: item.FileLeafRef, fileType: item[".fileType"], isFolder: false }))}
        getUploadItems={() => resolveCmHixUploadItems(selectedItems?.items, currentDirectory, oneDriveRootDetails, isInOneDrive.current)}
        getAccessToken={() => authModule.getGraphAccessToken()}
      />}
      {showDeleteDialog && <CMDeleteModal showDialog={showDeleteDialog} closeDialog={() => setShowDeleteDialog(false)} selectedItems={selectedItems?.items} closeOnSuccess={onDeleteCloseSuccess} />}
      {showCancelAssignmentDialog && <CMCancelAssignmentModal showDialog={showCancelAssignmentDialog} closeDialog={() => setShowCancelAssignmentDialog(false)} closeOnSuccess={onCancelAssignmentSuccess} selectedItem={selectedItem} />}
      {isCMErrorModalOpen && <CMErrorModal message={errorMessage} showDialog={isCMErrorModalOpen} closeDialog={() => setIsCMErrorModalOpen(false)} />}
      {isCMMoveFilesListPanelOpen && <CMMoveFilesListPanel panelIsOpen={isCMMoveFilesListPanelOpen} closePanel={() => setIsCMMoveFilesListPanelOpen(false)} />}
      {isFileUploadProgressPanelOpen && <CMFileUploadProgressPanel panelIsOpen={isFileUploadProgressPanelOpen} closePanel={() => setIsFileUploadProgressPanelOpen(false)} />}
      {showConfirmMoveToDialog && !moveTo.moveToEnabled && <CMConfirmModal
        title={(moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? languageStrings.MoveItems : languageStrings.CopyItems}
        message={languageStrings.SelectDestinationDirectory}
        showDialog={showConfirmMoveToDialog}
        closeDialog={() => {
          dispatch(setContentManagerMoveTo({
            moveToEnabled: false,
            workingDirectories: [],
            selectedFiles: [],
            siteUrl: "",
            sourceServerRelPath: "",
            progressCountCompleted: 0,
            progressCountTotal: 0
          }));
          setShowConfirmMoveToDialog(false)
        }}
        closeText=""
        confirmText={languageStrings.Ok}
        onConfirm={() => { onConfirmMoveFiles(false) }}
      />}
      {showConfirmMoveToDialog
        && moveTo.moveToEnabled
        && (moveTo.mode === ContentManagerCopyMoveModeEnum.Copy || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyAll || currentDirectory?.id !== moveToDirectory?.id)
        && <CMConfirmModal
          title={`${languageStrings.Confirm} ${(moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? languageStrings.MoveItems : languageStrings.CopyItems}`}
          htmlContent={htmlConfirmMessage}
          showDialog={showConfirmMoveToDialog}
          closeDialog={() => setShowConfirmMoveToDialog(false)}
          closeText={languageStrings.Cancel}
          confirmText={languageStrings.Yes}
          onConfirm={() => { onConfirmMoveFiles(true) }}
          isBusy={isBusyCreatingMoveToJobQue}
        />}
    </>
  )
};
